(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  var PRIVATE_PANEL_PROPERTIES = [
    'Panel Project',
    'Panel Orientation',
    'Panel Overlap',
    'Panel Media Width',
    'Panel Length'
  ];

  function setPrivateProperty(form, propertyName, value) {
    P.forms.setProperty(form, '_' + propertyName, value, {
      marker: 'private-panel-' + propertyName.toLowerCase().replace(/\s+/g, '-'),
      disableWhenEmpty: true
    });
  }

  function hidePublicProperty(form, propertyName) {
    P.forms.propertyInputs(propertyName, form).forEach(function (input) {
      input.disabled = true;
    });
  }

  function sanitizePanelProperties(form) {
    if (!form) return;

    PRIVATE_PANEL_PROPERTIES.forEach(function (propertyName) {
      var value = P.forms.getPropertyValue(propertyName, form);

      setPrivateProperty(form, propertyName, value);
      hidePublicProperty(form, propertyName);
    });

    var equalPanels =
      P.util.normalizeText(P.forms.getPropertyValue('Panel Sizing', form)) ===
      'equal panel widths';

    P.forms.propertyInputs('Last Panel Coverage', form).forEach(function (input) {
      input.disabled = equalPanels || !String(input.value || '').trim();
    });
  }
function removeEmptyProperties(formData) {
  var emptyKeys = Object.create(null);
  var nonEmptyKeys = Object.create(null);

  formData.forEach(function (value, key) {
    if (!/^properties\[.*\]$/.test(key)) return;

    if (value === null || value === undefined || String(value).trim() === '') {
      emptyKeys[key] = true;
    } else {
      nonEmptyKeys[key] = true;
    }
  });

  Object.keys(emptyKeys).forEach(function (key) {
    if (!nonEmptyKeys[key]) formData.delete(key);
  });
}
  function handleFormData(event) {
    var form = event.target;
    var formData = event.formData;

    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    PRIVATE_PANEL_PROPERTIES.forEach(function (propertyName) {
      var publicKey = 'properties[' + propertyName + ']';
      var privateKey = 'properties[_' + propertyName + ']';
      var value = P.forms.getPropertyValue(propertyName, form);

      if (value) {
        formData.set(privateKey, value);
      } else {
        formData.delete(privateKey);
      }

      formData.delete(publicKey);
    });

    var panelSizing =
      formData.get('properties[Panel Sizing]') ||
      P.forms.getPropertyValue('Panel Sizing', form);

    if (P.util.normalizeText(panelSizing) === 'equal panel widths') {
      formData.delete('properties[Last Panel Coverage]');
    }
    removeEmptyProperties(formData);
  }

  function prepareForm(form) {
    if (!form || form.dataset.printaraCartReady === 'true') return;

    form.dataset.printaraCartReady = 'true';
    form.addEventListener('formdata', handleFormData);

    form.addEventListener(
      'submit',
      function () {
        sanitizePanelProperties(form);
      },
      true
    );
  }

  function prepareAllForms() {
    P.forms.all().forEach(prepareForm);
  }

  function validateTerms(event, form) {
    var terms = document.getElementById('termsCheckbox');

    if (terms && !terms.checked) {
      event.preventDefault();
      alert('You must agree to the Terms & Conditions before adding to cart.');
      return false;
    }

    if (P.calculator && P.calculator.recalculate) {
      P.calculator.recalculate();
    }

    sanitizePanelProperties(form);
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button =
        event.target.closest &&
        event.target.closest(
          '.product-form__submit, [name="add"], [type="submit"]'
        );

      if (!button) return;

      var form = button.closest('form[action*="/cart/add"]');
      if (!form) return;

      prepareForm(form);
      validateTerms(event, form);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      prepareForm(form);
      validateTerms(event, form);
    },
    true
  );

  var queued = false;

  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;

    window.requestAnimationFrame(function () {
      queued = false;
      prepareAllForms();
    });
  });

  function init() {
    prepareAllForms();

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  P.util.ready(init);
  document.addEventListener('shopify:section:load', prepareAllForms);
})(window, document);
